import { LocalesList, LocaleType } from "@/hooks/system/useChangeLocale";
import { notification } from "antd";
import { ArgsProps } from "antd/lib/notification";

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

export const openExternalLink = (link: string) => {
  window.open(link, "_blank", "noopener,noreferrer");
};

// TODO: выдает CORS, ждем бэк, попросить добавить заголовки
export const downloadHandler = async (url: string) => {
  if (!url) {
    throw new Error("Resource URL not provided! You need to provide one");
  }

  try {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Download failed with status ${response.status}`);
    }

    const blob = await response.blob();
    const objectUrl = window.URL.createObjectURL(blob);

    const element = document.createElement("a");
    element.href = objectUrl;
    element.download = "file";
    document.body.appendChild(element);
    element.click();
    element.remove();

    window.URL.revokeObjectURL(objectUrl);
  } catch (error) {
    console.warn("Failed to download", error);
  }
};

export const isLanguageCode = (value: string): value is LocaleType => {
  return LocalesList.includes(value as LocaleType);
};

export const hashHandleScroll = (tags: string[], currentHash: string) => {
  const sections = tags
    .map(tag => {
      const element = document.querySelector(tag);
      if (!element) return null;
      const rect = element.getBoundingClientRect();
      return { url: tag, top: rect.top };
    })
    .filter(Boolean);

  const offset = 100;
  const activeSection = sections.reduce(
    (prev, curr) => {
      if (curr!.top - offset <= 0 && (prev === null || curr!.top > prev.top)) {
        return curr;
      }
      return prev;
    },
    null as { url: string; top: number } | null,
  );

  if (activeSection && activeSection.url !== currentHash) {
    return activeSection.url;
  }
};

// TODO: Сделать описания для нотификаций
export const openErrorNotification = (data: ArgsProps) => {
  notification.error(data);
};

export const openSuccessFormNotification = (data: ArgsProps) => {
  notification.success(data);
};
